export const SET_REGISTRATION_USER = 'SET_REGISTRATION_USER';
export const SET_REGISTRATION_ACCOUNT = 'SET_REGISTRATION_ACCOUNT';
export const SET_ACCOUNT_ADDRESS_STATES = 'SET_ACCOUNT_ADDRESS_STATES';
export const SET_ACCOUNT_ADDRESS_COUNTRIES = 'SET_ACCOUNT_ADDRESS_COUNTRIES';
export const SET_IS_SELF_REGISTRATION_ENABLED = 'SET_IS_SELF_REGISTRATION_ENABLED';